var excludePropertyNames = ['$$typeof', 'render', 'defaultProps', 'props', 'length', 'prototype', 'name', 'caller', 'callee', 'arguments'];
export function cloneEnumerableProperty(target, origin) {
  var compExtraPropertyNames = Object.keys(origin).filter(function (d) {
    return !excludePropertyNames.includes(d);
  });
  compExtraPropertyNames.forEach(function (d) {
    target[d] = origin[d];
  });
  return target;
}